import UserPaymentMethodApi from '@web/api/modules/UserPaymentMethod'
import {
  UserPaymentMethodState,
  UserPaymentMethodGettersTree,
  UserPaymentMethodMutationsTree,
  UserPaymentMethodActionsTree
} from '@web/store/types/modules/userPaymentMethod'

const state: UserPaymentMethodState = {
  userPaymentMethods: [],
  isLoaded: false
}

const getters: UserPaymentMethodGettersTree = {
  userPaymentMethods: ({ userPaymentMethods }) => userPaymentMethods,
  isLoaded: ({ isLoaded }) => isLoaded
}

const mutations: UserPaymentMethodMutationsTree = {
  receiveUserPaymentMethods (state, userPaymentMethods) {
    state.userPaymentMethods = userPaymentMethods
  },
  removeUserPaymentMethod (state, id) {
    state.userPaymentMethods = state.userPaymentMethods.filter(method => method.id !== id)
  },
  setIsLoaded (state, isLoaded) {
    state.isLoaded = isLoaded
  },
  logout (state) {
    state.userPaymentMethods = []
    state.isLoaded = false
  }
}

const actions: UserPaymentMethodActionsTree = {
  async fetchUserPaymentMethods ({ commit }) {
    commit('setIsLoaded', false)
    const userPaymentMethods = await UserPaymentMethodApi.fetchAll()
    commit('receiveUserPaymentMethods', userPaymentMethods)
    commit('setIsLoaded', true)
  },
  fetchCachedUserPaymentMethods ({ state, dispatch }) {
    if (state.isLoaded) {
      return Promise.resolve()
    }
    return dispatch('fetchUserPaymentMethods')
  },
  async removeUserPaymentMethod ({ commit }, id) {
    await UserPaymentMethodApi.remove(id)
    commit('removeUserPaymentMethod', id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any
